import { KEY } from "@/react/components/table/useTableMutations";

const mergeNewRowIntoSelection =
  ({ addRows, setRowSelection }) =>
  (rowsToAdd, schema) =>
    addRows(rowsToAdd, schema).then((newRows) => {
      setRowSelection((prevSelection) => {
        const newSelection = { ...prevSelection };
        newRows.forEach((row) => {
          if (!Object.hasOwn(prevSelection, row[KEY])) {
            newSelection[row[KEY]] = true;
          }
        });
        return newSelection;
      });
    });

export default mergeNewRowIntoSelection;
